import { Fragment, createElement, lazy } from 'react';
import { type RouteObject } from 'react-router';

import { OnboardingLayout, SignInLayout } from '@/layout';

const routes: RouteObject[] = [
  {
    path: 'auth',
    Component: SignInLayout,
    children: [
      {
        path: 'signin',
        Component: OnboardingLayout,
        children: [
          {
            path: '',
            Component: lazy(() => import('@/page/auth/SignInPage')),
          },
        ],
      },

      {
        path: 'tenant-selection',
        Component: OnboardingLayout,
        children: [
          {
            path: '',
            Component: lazy(() => import('@/page/auth/TenantSelectionPage')),
          },
        ],
      },

      {
        path: 'reset-password',
        Component: OnboardingLayout,
        children: [
          {
            path: '',
            Component: lazy(() => import('@/page/auth/ResetPasswordPage')),
          },
        ],
      },

      {
        path: 'password-change-complete',
        Component: OnboardingLayout,
        children: [
          {
            path: '',
            Component: lazy(
              () => import('@/page/auth/PasswordChangeCompletePage'),
            ),
          },
        ],
      },

      {
        path: '',
        Component: OnboardingLayout,
        children: [
          {
            path: 'service-preparation-notice',
            Component: lazy(
              () => import('@/page/auth/ServicePreparationNoticePage'),
            ),
          },
          {
            path: 'send-verification-code',
            Component: lazy(() => import('@/page/auth/SendVerificationCode')),
          },
          {
            path: 'verification-email',
            Component: lazy(() => import('@/page/auth/VerificationEmail')),
          },
          {
            path: 'onboarding',
            Component: lazy(() => import('@/page/onboarding/OnboardingPage')),
          },
          {
            path: 'offboarding',
            Component: lazy(() => import('@/page/offboarding/OffboardingPage')),
          },
        ],
      },
      {
        path: '',
        Component: OnboardingLayout,
        children: [
          {
            path: 'new-password',
            Component: lazy(() => import('@/page/auth/NewPasswordPage')),
          },
        ],
      },

      {
        path: 'signup',
        Component: OnboardingLayout,
        children: [
          {
            path: '',
            Component: lazy(() => import('@/page/auth/SignUpPage')),
          },
          {
            path: 'qr',
            Component: lazy(() => import('@/page/auth/QRSignUpPage')),
            ErrorBoundary: lazy(() => import('@/page/auth/QRSignUpErrorPage')),
            children: [
              {
                path: '',
                Component: lazy(
                  () => import('@/page/auth/QRSignUpGoogleSignInPage'),
                ),
              },
              {
                path: 'failed',
                Component: lazy(() => import('@/page/auth/QRSignUpFailedPage')),
              },
              {
                path: 'form',
                Component: lazy(() => import('@/page/auth/QRSignUpFormPage')),
              },
              {
                path: 'complete',
                Component: lazy(
                  () => import('@/page/auth/QRSignUpCompletePage'),
                ),
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: 'logout',
    Component: () => {
      location.href = '/';
      return createElement(Fragment);
    },
  },
];

export default routes;
